import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { useSelector } from "react-redux";

const useLanguage = (options?: Toolkit.GoogleAnalytics.Options) => {
    return useSelector((state: ApplicationState) => state.context.session.language?.languageCode);
};

export default useLanguage;
